"use client";

import { usePathname } from "next/navigation";
import { ReactNode } from "react";
import { useSite } from "@/lib/hooks/site";

// Pages where header SHOULD be sticky (non-list pages)
const STICKY_PAGE_PREFIXES = [
  "/blog",
  "/hakkimizda",
  "/iletisim",
  "/gizlilik",
  "/kvkk",
  "/kullanim-sartlari",
  "/ekle",
  "/site-haritasi",
  "/sss",
  "/404",
  "/500",
  "/kullanim-kosullari",
  "/yasal-uyari",
  "/hesabim",
  "/favori-mekanlar"
];

function shouldHeaderBeSticky(pathname: string, trainerRoute?: string): boolean {
  // Home page - NOT sticky: header scrolls away, the hero search bar pins instead
  if (pathname === "/") return false;

  // Trainer page - sticky
  if (trainerRoute && pathname.startsWith(`/${trainerRoute}`)) return true;

  // Check if path starts with any sticky prefix
  for (const prefix of STICKY_PAGE_PREFIXES) {
    if (pathname.startsWith(prefix)) return true;
  }

  // Pages ending with "-indirimleri" - sticky (except sirket-indirimleri)
  if (pathname.endsWith("-indirimleri") && !pathname.endsWith("sirket-indirimleri")) return true;

  // Everything else (venue list pages like /spormerkezleri, /kadikoy-spormerkezleri) - not sticky
  return false;
}

interface HeaderWrapperProps {
  children: ReactNode;
}

export default function HeaderWrapper({ children }: HeaderWrapperProps) {
  const pathname = usePathname();
  const site = useSite();
  const trainerRoute = site?.setting?.routes?.trainer;
  const isSticky = shouldHeaderBeSticky(pathname, trainerRoute);
  const isHomepage = pathname === "/";

  return (
    <header
      id="site-navigation"
      className={`${isHomepage ? "md:relative md:bg-transparent" : "md:bg-white"} md:h-[104px] gap-2 md:gap-0 w-full flex flex-col justify-center items-center z-[99] ${isSticky ? "md:sticky md:top-0" : ""
        }`}
    >
      {children}
    </header>
  );
}
